module.exports = __webpack_public_path__ + "img/it.b750d4e3.svg";